import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Stack, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { regNewsData } from "../../Api/News";
import { NewsData } from "../../Objects/NewsDate";
import ImagePicker from "../atoms/ImagePicker";

export interface NewsEditDialogProps {
    news_id?: number
    dialogProps?: Omit<DialogProps, "open">
    onClose: () => void
}
export function NewsEditDialog({
    news_id,
    dialogProps,
    onClose,
}: NewsEditDialogProps): React.ReactElement | null {
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)

    const [editNews, setEditNews] = React.useState<NewsData>()
    const [saveEnable, setSaveEnable] = React.useState<boolean>(false)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (editNews) {
            if (news_id) {
                //validate
                // @todo
            } else if (news_id === 0) {
                regNewsData({
                    newsData: editNews
                }, {signal: abortController.signal}).then(() => {
                    enqueueSnackbar("登録しました", { variant: "success" })
                    setOpen(false)
                }).catch((e: any) => {
                    if( e.__CANCEL__ ) {
                        console.info("canceled")
                    } else if (e instanceof ApiError) {
                        enqueueSnackbar(e.message, { variant: "error" })
                    } else if (e instanceof Error) {
                        enqueueSnackbar(e.message, { variant: "error" })
                    }else {
                        enqueueSnackbar("通信に失敗しました", { variant: "error" })
                    }
                })
            }
        }
    }, [abortController, news_id, editNews, enqueueSnackbar])

    React.useEffect(() => {
        if (news_id) {
        } else if (news_id === 0) {
            setEditNews({})
            setOpen(true)
        }
    }, [news_id])

    React.useEffect(() => {
        let _saveEnable = true;
        if (!editNews?.title) {
            _saveEnable = false
        }
        if (!editNews?.news_detail && !editNews?.newsimg_data) {
            _saveEnable = false
        }
        setSaveEnable(_saveEnable)
    }, [editNews])

    if (news_id === undefined) {
        return null
    }

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            TransitionProps={{
                onExited: () => {
                    onClose()
                }
            }}
            fullWidth
        >
            <DialogTitle>{news_id > 0 ? "ニュース登録" : "ニュース編集"}</DialogTitle>
            <DialogContent>
                <Stack
                    spacing={2}
                    alignItems="center"
                    pt={0.5}
                >
                    <TextField
                        label="タイトル"
                        value={editNews?.title ? editNews.title : ""}
                        onChange={e => {
                            setEditNews(prev => {
                                return {
                                    ...prev,
                                    title: e.target.value
                                }
                            })
                        }}
                        size="small"
                        fullWidth
                    />
                    <ImagePicker
                        imageData={editNews?.newsimg_data ? editNews.newsimg_data : undefined}
                        onChange={data => {
                            setEditNews(prev => {
                                return {
                                    ...prev,
                                    newsimg_data: data
                                }
                            })
                        }}
                        sx={{
                            width: 300,
                            maxWidth: "100%",
                            height: 300,
                        }}
                        imageSx={{
                            objectFit: "contain"
                        }}
                    />
                    <TextField
                        label="本文"
                        value={editNews?.news_detail ? editNews.news_detail : ""}
                        onChange={e => {
                            setEditNews(prev => {
                                return {
                                    ...prev,
                                    news_detail: e.target.value
                                }
                            })
                        }}
                        size="small"
                        rows={10}
                        multiline
                        fullWidth
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setOpen(false)
                    }}
                >キャンセル</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        doSave()
                    }}
                    disabled={!saveEnable}
                >保存</Button>
            </DialogActions>
        </Dialog>
    )
}